import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TenantUnitReloadService {
	readonly tenantUnitSaved$ = new Subject<void>();
}
